import React from 'react';
import { useIsMobile } from '../../utils/useMediaQuery';

export function SelectionGrid({ selections }) {
    const isMobile = useIsMobile();

    return (
        <div style={{
            padding: isMobile ? '20px' : '60px 80px',
            background: '#fafafa',
        }}>
            <h2 style={{
                fontSize: '28px',
                fontWeight: '300',
                letterSpacing: '2px',
                marginBottom: '16px',
                color: '#1a1a1a',
            }}>
                SAVED SELECTIONS
            </h2>

            <p style={{
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#666',
                marginBottom: '40px',
            }}>
                Review your saved seating selections and use the form to begin a conversation with our team.<br />
                We'll help refine layouts, confirm materials, and guide pricing based on your space and preferences.
            </p>

            {selections.length > 0 && (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: isMobile ? '10px' : '20px',
                }}>
                    {selections.map(item => (
                        <a key={item.id} style={{
                            background: '#ffffff',
                            overflow: 'hidden',
                        }}
                        href={`${item.link}`}>
                            {item.image && (
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    style={{
                                        aspectRatio: '1',
                                        width: '100%',
                                        objectFit: 'cover',
                                        display: 'block',
                                    }}
                                />
                            )}
                            <div style={{
                                padding: '10px',
                                textAlign: 'center'
                            }}>
                                <h3 style={{
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    margin: '0 0 6px 0',
                                    color: '#1a1a1a',
                                }}>
                                    {item.name}
                                </h3>
                                <p style={{
                                    fontSize: '12px',
                                    color: '#999',
                                    margin: 0,
                                }}>
                                    (Layout, material and colors to be determined)
                                </p>
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}
